// extracted by mini-css-extract-plugin
module.exports = {"metric-footer":"MetricFooter_metric-footer__1JfGS"};